import { useState } from "react";
import { Button } from "reactstrap";


import "./CourseEnquiryButton.css";
import CourseEnquiryModal from "../common/Contact/CourseEnquiryModal";

function CourseEnquiryButton({ courseName = "CAD Automation Training", buttonText = "Contact Us"
}) {
    const [isEnquiryOpen, setIsEnquiryOpen] = useState(false);

    const toggleEnquiry = () => { setIsEnquiryOpen((prev) => !prev); };

    return (
        <>
            <div className="course-enquiry-button-wrapper">
                <Button color="primary" className="fs-5" onClick={toggleEnquiry}>
                    <span>{buttonText}</span>
                </Button>
            </div>

            <CourseEnquiryModal isOpen={isEnquiryOpen} toggle={toggleEnquiry} courseName={courseName} />
        </>
    );
}

export default CourseEnquiryButton;